import { KEYWORD_TRIGGERED_BANNER_SUCCESS } from "./const";

function action(markup) {
  return {
    type: KEYWORD_TRIGGERED_BANNER_SUCCESS,
    markup,
  };
}

export default action;
